"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "UserProfile";

export default {
  getUserProfile() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetUserProfile`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  selectAllSensorUsages() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/SelectAllSensorUsages`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  insertSensorUsages(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/InsertSensorUsages`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  reportSettingChange(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/ReportSettingChange`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  }
};
